import type { RouteObject } from 'react-router';

import { Suspense } from 'react';
import { Outlet } from 'react-router';

import lazyWithReload from 'src/utils/lazyWithReload';

import { CONFIG } from 'src/global-config';
import { DashboardLayout } from 'src/layouts/dashboard';

import { LoadingScreen } from 'src/components/loading-screen';

import { AuthGuard } from 'src/auth/guard';

import { usePathname } from '../../../routes/hooks';

// ----------------------------------------------------------------------

// report
const CallLogs = lazyWithReload(() => import('src/pages/reports/call-logs'));
const MessageReport = lazyWithReload(() => import('src/pages/reports/message-report'));
const ConversationReport = lazyWithReload(() => import('src/pages/reports/conversation-report'));
const SupportReport = lazyWithReload(() => import('src/pages/reports/support-report'));
// -------------------------=---------------------------------------------

function SuspenseOutlet() {
  const pathname = usePathname();
  return (
    <Suspense key={pathname} fallback={<LoadingScreen />}>
      <Outlet />
    </Suspense>
  );
}

const dashboardLayout = () => (
  <DashboardLayout>
    <SuspenseOutlet />
  </DashboardLayout>
);

export const reportRoutes: RouteObject[] = [
  {
    path: 'report',
    element: CONFIG.auth.skip ? dashboardLayout() : <AuthGuard>{dashboardLayout()}</AuthGuard>,
    children: [
      { path: 'call-logs', element: <CallLogs /> },
      { path: 'message-report', element: <MessageReport /> },
      { path: 'conversation-report', element: <ConversationReport /> },
      { path: 'support-report', element: <SupportReport /> },
    ],
  },
];
